import script from "./rolefenpei.vue?vue&type=script&setup=true&lang=js"
export * from "./rolefenpei.vue?vue&type=script&setup=true&lang=js"

import "./rolefenpei.vue?vue&type=style&index=0&id=5e4f542a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5e4f542a"]])

export default __exports__